import axios from 'axios';
import ApiService from '../services/api';

export type FeatureFlagResponse = {
    id: string;
    feature: string;
    enabled: boolean;
    createdAt: string;
    updatedAt: string;
};

/**
 * GET /feature-flags/{feature}
 * 200 -> flag registrada (ver `enabled`); 404 -> flag não existe (retorna null).
 * Qualquer outro erro é propagado.
 */
export const fetchFeatureFlag = async (feature: string): Promise<FeatureFlagResponse | null> => {
    const apiService = new ApiService(undefined, "");
    try {
        const response = await apiService.get<FeatureFlagResponse>(`/feature-flags/${encodeURIComponent(feature)}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
            return null;
        }
        throw error;
    }
};
